/* eslint-disable max-len */
import { INTL_IDS } from './messages';
import { INTL_IDS as PAYMENTS_INTL_IDS } from '../messages';

export const CHANGE_INPUT = 'app/Payments/FlexDraft/CHANGE_INPUT';

export const CHANGE_STEP = 'app/Payments/FlexDraft/CHANGE_STEP';

export const CHANGE_VALIDATION_FAILURE = 'app/Payments/FlexDraft/CHANGE_VALIDATION_FAILURE';

export const FLEX_DRAFT_CHANGE = 'app/Payments/FlexDraft/FLEX_DRAFT_CHANGE';
export const FLEX_DRAFT_CHANGE_FAILURE = 'app/Payments/FlexDraft/FLEX_DRAFT_CHANGE_FAILURE';
export const FLEX_DRAFT_CHANGE_SUCCESS = 'app/Payments/FlexDraft/FLEX_DRAFT_CHANGE_SUCCESS';

export const FLEX_DRAFT_FETCH_STATUS = 'app/Payments/FlexDraft/FLEX_DRAFT_FETCH_STATUS';
export const FLEX_DRAFT_FETCH_STATUS_FAILURE = 'app/Payments/FlexDraft/FLEX_DRAFT_FETCH_STATUS_FAILURE';
export const FLEX_DRAFT_FETCH_STATUS_SUCCESS = 'app/Payments/FlexDraft/FLEX_DRAFT_FETCH_STATUS_SUCCESS';

export const RESET_CONFIRMATION = 'app/Payments/FlexDraft/RESET_CONFIRMATION';

export const RESET_FLEX_DRAFT_STATE = 'app/Payments/FlexDraft/RESET_FLEX_DRAFT_STATE';

export const RESET_FORM_STATE = 'app/Payments/FlexDraft/RESET_FORM_STATE';

export const RESET_REQUEST_STATUS = 'app/Payments/FlexDraft/RESET_REQUEST_STATUS';

export const SET_IS_AMOUNT_DRAWER_OPEN = 'app/Payments/FlexDraft/SET_IS_AMOUNT_DRAWER_OPEN';

export const SET_IS_IN_FLEX_DRAFT_FLOW = 'app/Payments/FlexDraft/SET_IS_IN_FLEX_DRAFT_FLOW';

export const SET_IS_MODAL_OPEN = 'app/Payments/FlexDraft/SET_IS_MODAL_OPEN';

export const SET_IS_SCHEDULE_DRAWER_OPEN = 'app/Payments/FlexDraft/SET_IS_SCHEDULE_DRAWER_OPEN';

export const SET_IS_SECOND_ACCOUNT_FORM_ENABLED = 'app/Payments/FlexDraft/SET_IS_SECOND_ACCOUNT_FORM_ENABLED';

export const SET_SELECTED_DRAFT_SCHEDULE_STEP = 'app/Payments/FlexDraft/SET_SELECTED_DRAFT_SCHEDULE_STEP';

export const UPDATE_AMOUNT = 'app/Payments/FlexDraft/UPDATE_AMOUNT';

export const UPDATE_FORM_ERROR = 'app/Payments/FlexDraft/UPDATE_FORM_ERROR';

// Screen copy

export const FLEX_DRAFT_CONFIRMATION_DICTIONARY = {
  change: {
    errorHeader: 'Flexible Drafting Confirmation',
    successHeader: 'Flexible Drafting Confirmation',
    successLinkLabel: 'Return to Payments',
    successSubHeader: 'Success! We received your request to edit your Flexible Drafting settings',
    successText: 'Your request has been received and will be processed. An email will be sent to you confirming that we have received your request.',
  },
  enable: {
    errorHeader: 'Enrollment Request Confirmation',
    successHeader: 'Enrollment Request Confirmation',
    successLinkLabel: 'Return to Payments',
    successSubHeader: 'Success! We received your request to enroll in Flexible Drafting',
    successText: 'Your request has been received and will be processed. An email will be sent to you confirming that we have received your request.',
  },
  shared: {
    animationName: 'flyingMoney',
    errorLinkLabel: 'Return to Payments',
    errorSubHeader: 'Sorry! Something went wrong',
    errorText: 'We apologize for the inconvenience. Please try again later. ',
    labelArray: [
      { key: 'confirmationNumber', label: 'Confirmation Details' },
      { key: 'totalPayment', label: 'Amount' },
      { key: 'beginDate', label: 'Start Date' },
    ],
  },
};

export const FLEX_DRAFT_DRAWER_DICTIONARY = {
  amount: { headerText: 'Edit Flexible Drafting Amount' },
  sources: {
    buttonLabel: 'Add Payment Source',
    headerText: 'Add Payment Information',
    paragraph: [
      'By entering in the information for the bank account(s) below and clicking “Add Payment Source”, you affirm that you are the authorized bank account holder of the account(s).',
      'If you wish to draft from a bank account where you are not the authorized bank account holder, please call <a>{{customerServicePhoneNumber}}.</a>',
    ],
    secondAccountText: 'Add Second Payment Account (Optional)',
  },
};

export const FLEX_DRAFT_INFO_COPY_DICTIONARY = {
  confirmation: {
    change: {
      scheduleBiWeekly: [
        {
          iconAlignSelf: 'flex-start',
          text: INTL_IDS.INFOCOPY_CONFIRMATION_BIWEEKLY_CHANGE_CONFIRMATIONLETTER,
          variant: 'info',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_BIWEEKLY_WEEKENDHOLIDAY,
          variant: 'pending',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_BIWEEKLY_QUESTIONS,
          variant: 'info',
        },
      ],
      scheduleSemiMonthly: [
        {
          iconAlignSelf: 'flex-start',
          text: INTL_IDS.INFOCOPY_CONFIRMATION_SEMIMONTHLY_CHANGE_CONFIRMATIONLETTER,
          variant: 'info',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_SEMIMONTHLY_WEEKENDHOLIDAY,
          variant: 'pending',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_SEMIMONTHLY_QUESTIONS,
          variant: 'info',
        },
      ],
    },
    enable: {
      scheduleBiWeekly: [
        {
          iconAlignSelf: 'flex-start',
          text: INTL_IDS.INFOCOPY_CONFIRMATION_BIWEEKLY_ENABLE_CONFIRMATIONLETTER,
          variant: 'info',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_BIWEEKLY_WEEKENDHOLIDAY,
          variant: 'pending',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_BIWEEKLY_QUESTIONS,
          variant: 'info',
        },
      ],
      scheduleSemiMonthly: [
        {
          iconAlignSelf: 'flex-start',
          text: INTL_IDS.INFOCOPY_CONFIRMATION_SEMIMONTHLY_ENABLE_CONFIRMATIONLETTER,
          variant: 'info',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_SEMIMONTHLY_WEEKENDHOLIDAY,
          variant: 'pending',
        },
        {
          text: INTL_IDS.INFOCOPY_CONFIRMATION_SEMIMONTHLY_QUESTIONS,
          variant: 'info',
        },
      ],
    },
  },
  editAmount: [
    {
      text: INTL_IDS.INFOCOPY_EDITAMOUNT_IFTWOBANKACCOUNTS,
      variant: 'info',
    },
  ],
  enable: [
    {
      text: 'First placeholder text.',
      variant: 'warning',
    },
    {
      text: 'Second placeholder text.',
      variant: 'pending',
    },
    {
      text: 'Third placeholder text.',
      variant: 'info',
    },
  ],
  payFrom: [{
    text: INTL_IDS.INFOCOPY_PAYFROM_IFTWOBANKACCOUNTS,
    variant: 'info',
  }],
  setup: [
    {
      text: 'Lorem ipsum dolor sit amet consectetur. Lectus quam mauris ac praesent sit ut arcu maecenas mauris.',
      variant: 'pending',
    },
  ],
};

export const FLEX_DRAFT_REVIEW_DICTIONARY = {
  headerTitle: 'Review Flexible Drafting Settings',
  heading: 'Almost done. Please review your settings below',
  paragraphText: 'Processing a Flexible Drafting request can take up to 15 business days.',
};

export const FLEX_DRAFT_SCHEDULE_BI_WEEKLY = 'scheduleBiWeekly';
export const FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY = 'scheduleSemiMonthly';

export const FLEX_DRAFT_SCHEDULE_FORM_BI_WEEKLY_DICTIONARY = {
  startingDay: {
    heading: 'Starting Day',
    menuItems: [
      { display: '1st', value: '1' },
      { display: '2nd', value: '2' },
      { display: '3rd', value: '3' },
      { display: '4th', value: '4' },
      { display: '5th', value: '5' },
      { display: '6th', value: '6' },
      { display: '7th', value: '7' },
      { display: '8th', value: '8' },
      { display: '9th', value: '9' },
      { display: '10th', value: '10' },
    ],
  },
  startingMonth: {
    heading: 'Starting Month',
    menuItems: [
      { display: 'January', value: '1' },
      { display: 'February', value: '2' },
      { display: 'March', value: '3' },
      { display: 'April', value: '4' },
      { display: 'May', value: '5' },
      { display: 'June', value: '6' },
      { display: 'July', value: '7' },
      { display: 'August', value: '8' },
      { display: 'September', value: '9' },
      { display: 'October', value: '10' },
      { display: 'November', value: '11' },
      { display: 'December', value: '12' },
    ],
  },
};

export const FLEX_DRAFT_SCHEDULE_FORM_COPY_DICTIONARY = {
  default: { title: 'Select Payment Schedule' },
  [FLEX_DRAFT_SCHEDULE_BI_WEEKLY]: {
    backButton: 'Go Back',
    heading: 'Select a preferred starting date',
    infoSectionData: [
      {
        iconAlignSelf: 'flex-start',
        text: INTL_IDS.SCHEDULE_FORMCOPY_BIWEEKLY_INFOCOPY_AFULLYEAR,
        variant: 'info',
      },
      {
        iconAlignSelf: 'flex-start',
        text: INTL_IDS.SCHEDULE_FORMCOPY_BIWEEKLY_INFOCOPY_CONFIRMATIONLETTER,
        variant: 'info',
      },
    ],
    selectButton: 'Select Start Date',
    text: [
      INTL_IDS.SCHEDULE_FORMCOPY_BIWEEKLY_TEXT_1,
      INTL_IDS.SCHEDULE_FORMCOPY_BIWEEKLY_TEXT_2,
    ],
    title: 'Select Preferred Start Date',
  },
  [FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY]: {
    backButton: 'Go Back',
    heading: 'Select Withdrawal Dates',
    infoSectionData: [
      {
        text: INTL_IDS.SCHEDULE_FORMCOPY_SEMIMONTHLY_INFOCOPY_FUNDS,
        variant: 'info',
      },
    ],
    selectButton: 'Select Payment Dates',
    text: INTL_IDS.SCHEDULE_FORMCOPY_SEMIMONTHLY_TEXT,
    title: 'Select Payment Dates',
  },
};

export const FLEX_DRAFT_SCHEDULE_FORM_SEMI_MONTHLY_DICTIONARY = {
  firstDraft: {
    heading: 'First Draft (Select one)',
    menuItems: [{
      label: '1st Day of the Month',
      ordinalNumber: '1st',
      value: '1',
    }, {
      label: '5th Day of the Month',
      ordinalNumber: '5th',
      value: '5',
    }],
  },
  secondDraft: {
    heading: 'Second Draft (Select one)',
    menuItems: [{
      label: '10th Day of the Month',
      ordinalNumber: '10th',
      value: '10',
    }, {
      label: '15th Day of the Month',
      ordinalNumber: '15th',
      value: '15',
    }],
  },
};

export const FLEX_DRAFT_SCHEDULE_SELECT_LIST = [
  {
    description: {
      desktopText: INTL_IDS.SCHEDULE_SEMIMONTHLY_DESCRIPTION_DESKTOP,
      mobileText: INTL_IDS.SCHEDULE_SEMIMONTHLY_DESCRIPTION_MOBILE,
    },
    label: 'Semi-Monthly',
    value: FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY,
  },
  {
    // eslint-disable-next-line max-len
    description: {
      desktopText: INTL_IDS.SCHEDULE_BIWEEKLY_DESCRIPTION_DESKTOP,
      mobileText: INTL_IDS.SCHEDULE_BIWEEKLY_DESCRIPTION_MOBILE,
    },
    label: 'Bi-Weekly',
    value: FLEX_DRAFT_SCHEDULE_BI_WEEKLY,
  },
];

export const FLEX_DRAFT_SETUP_DICTIONARY = {
  headerText: 'Set Up Flexible Drafting',
  summaryButtonLabel: 'Review Settings',
};

export const FLEX_DRAFT_SPLASH_DICTIONARY = {
  buttonLabel: 'Enroll in Flexible Drafting',
  headerText: 'Enroll in semi-monthly or bi-weekly automatic payments (“Flexible Drafting”)',
  listText: [
    PAYMENTS_INTL_IDS.SPLASHPAGE_FLEXDRAFT_TEXT_MORTGAGEPAYMENTS,
    PAYMENTS_INTL_IDS.SPLASHPAGE_FLEXDRAFT_TEXT_ABILITYTOREMIT,
    PAYMENTS_INTL_IDS.SPLASHPAGE_FLEXDRAFT_TEXT_DESIGNATEUPTO,
  ],
};

export const FLEX_DRAFT_TOOLTIP_PROPS = {
  additionalPrincipal: {
    content: INTL_IDS.TOOLTIP_ADDITIONALPRINCIPAL_CONTENT,
    linkText: 'Got it',
    title: INTL_IDS.TOOLTIP_ADDITIONALPRINCIPAL_TITLE,
  },
  regularMonthlyPayment: {
    content: INTL_IDS.TOOLTIP_REGULARMONTHLYPAYMENT_CONTENT,
    linkText: 'Got it',
    title: INTL_IDS.TOOLTIP_REGULARMONTHLYPAYMENT_TITLE,
  },
};

export const PAYMENT_FLOW_TYPE_FLEX_DRAFT = 'flexdraft';

// Error variables
export const DEFAULT_FLEX_DRAFT_CHANGE_ERRORS = { additionalPrincipal: '' };

export const REASON_CODE_DICTIONARY = {
  35010.1011: {
    key: 'additionalPrincipal',
    message: 'Additional principal amount has to be greater than or equal to zero',
    screen: 'FlexDraftAmount',
  },
  35010.1012: {
    key: 'additionalPrincipal',
    message: 'Additional principal must be less than or equal to the max allowed additional principal',
    screen: 'FlexDraftAmount',
  },
};
